import React from 'react';
import './Header.css';

const Header = () => {

    return (
        <header>
            <section className="header-top">
                <section className="header-top-left">
                    <img className="header-top-left__logo" src="/mufg/assets/images/logo-mufg.png" alt="mufg logo" />
                    {/* <span className="header-top-left__pipe">
                    </span> */}
                    <span className="header-top-left__title">
                        &nbsp;
                    </span>
            </section>
                <section className="header-top-right">
                </section>
            </section>
            <section className="header-bottom">
            </section>
        </header>
    )
}

export default Header;